<ng-container *ngTemplateOutlet="isLoading ? loading : widget"></ng-container>

<ng-template #loading>
  <div class="post-widget-loading">
    <u-icon
      [model]="{ type: 'font', value: 'icon-file-image' }"
      [styles]="{ fontSize: '48px', color: 'var(--color-text-highlight)' }"
    ></u-icon>
  </div>
</ng-template>

<ng-template #widget>
  <widget-title
    [movedWidget]="movedWidget"
    [sectionButtons]="{ contextMenu: isOwnerOrAdmin }"
    [contextMenuOpened]="contextMenuOpened"
    (openContextMenu)="openContextMenu($event)"
    (navigate)="navigate()"
  ></widget-title>
  <u-galleria
    *ngIf="!!carouselData"
    [model]="carouselData"
    [showIndicators]="settings.post?.carousel?.length > 1"
    [showNavigators]="showNavigation"
    [autoPlay]="autoPlay"
    [autoplayInterval]="defaultAutoplayInterval"
    (onClick)="onClick($event)"
  ></u-galleria>
</ng-template>
